import React, { useReducer, useEffect } from 'react';
import './calender.css';
import Slider from './slider';
import Slot from './slot';
import useLoader from '../../../hooks/use-loader';
import UnavailableSlots from './unavailable';
import { useAppState } from '../../../contexts/appState'
import lodash from 'lodash';
import ErrorComponent from '../../Error-Component';
import { parseQueryString } from '../../../utils/utils'
import moment from 'moment';
import { calenderGATags, sendPageViewEvent } from '../../../utils/network';
import { srGetSlotsForDate, srGetSlots, srBookSlots } from '../../../sources/book-appointments'
const fetchSlot = (data) => {
  let morningList = [];
  let afternoonList = [];
  let eveningList = [];
  data.contents.time_wise_slots_list.forEach((cur) => {
    if (cur.part_of_the_day === 'Morning' && cur.center_wise_slots_list.length > 0) {
      morningList = cur.center_wise_slots_list[0]?.slot_list;
    }
    else if (cur.part_of_the_day === 'Afternoon' && cur.center_wise_slots_list.length > 0) {
      afternoonList = cur.center_wise_slots_list[0]?.slot_list;
    }
    else if (cur.part_of_the_day === 'Evening' && cur.center_wise_slots_list.length > 0) {
      eveningList = cur.center_wise_slots_list[0]?.slot_list;
    }
  });
  return { morningList, afternoonList, eveningList };
}

const Calender = ({ t, handleNext }) => {
  const params = parseQueryString();
  const auth_token = lodash.get(params, "auth_token");;
  const source_id = lodash.get(params, "source_id");
  const source_user_id = lodash.get(params, "source_user_id");
  const source_relation = lodash.get(params, "source_relation");
  const source_user_relation_id = lodash.get(params, "source_user_relation_id");

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }), {
    response: {},
    morningList: [],
    afternoonList: [],
    eveningList: [],
    selectedSlot: null,
    date: null,
    selectedTime: null,
    serviceError: false,
    errorMessage: ''
  }
  );

  const setSelectedSlot = (id, time, interval) => {
    setState({ selectedSlot: id, selectedTime: time, interval })
  };
  const { showLoading, hideLoading } = useLoader();
  const [{ user, booking, centerDetails }, dispatch] = useAppState();

  const loadSlotsForDate = async (date) => {
    showLoading();
    const request = {
      "doctor_id": centerDetails?.doctor_id || booking?.doctor_id,
      "partner_consult_center_id": centerDetails?.partner_consult_center_id || booking?.partner_consult_center_id,
      "date": date,
      "consultation_service_type": "4"
    }
    const response = await srGetSlotsForDate(request);
    if (lodash.get(response, "status") !== "success") {
      //error handling
      setState({ morningList: [], afternoonList: [], eveningList: [] });
    }
    else {
      const { morningList, afternoonList, eveningList } = fetchSlot(response);
      // if (morningList.length === 0 && afternoonList.length === 0 && eveningList.length === 0) {
      //   calenderGATags('No Slots Available', centerDetails?.name);
      // }
      setState({ morningList, afternoonList, eveningList, date })
    }
    hideLoading();
  };

  const dateSelected = (date) => {
    loadSlotsForDate(date);
  };

  const loadAllSlots = async () => {
    showLoading();
    const requestObj = {
      // "booking_jiohealthhubid": "WGTR-4282",
      // "primary_jiohealthhubid": "EEKS-6225",
      "doctor_id": centerDetails?.doctor_id || booking?.doctor_id,
      "partner_consult_center_id": centerDetails?.partner_consult_center_id || booking?.partner_consult_center_id,
      "consultation_service_type": "4",
      "order_id": booking?.order_id
    }
    const response = await srGetSlots(requestObj);
    if (lodash.get(response, "status") !== "success") {
      // error handling
      setState({ serviceError: true, errorMessage: lodash.get(response, "response.data.message", "Something went wrong, please try again") });
      hideLoading();

    } else {
      const slotRequest = {
        // "booking_jiohealthhubid": user?.bookingHealthId,
        // "primary_jiohealthhubid": user?.primaryHealthId,
        "doctor_id": centerDetails?.doctor_id || booking?.doctor_id,
        "partner_consult_center_id": centerDetails?.partner_consult_center_id || booking?.partner_consult_center_id,
        "date": response.contents[0].date,
        "consultation_service_type": "4"
      }
      const slotResponse = await srGetSlotsForDate(slotRequest);
      if (lodash.get(slotResponse, "status") !== "success") {
        setState({ morningList: [], afternoonList: [], eveningList: [] });
        // setState({ serviceError: true, errorMessage: lodash.get(slotResponse, "message", "Something went wrong, please try again") });
      } else {
        const { morningList, afternoonList, eveningList } = fetchSlot(slotResponse);
        // if (morningList.length === 0 && afternoonList.length === 0 && eveningList.length === 0) {
        //   calenderGATags('No Slots Available', centerDetails?.name);
        // }
        setState({ ...response, morningList, afternoonList, eveningList, date: response.contents[0].date });
      }
      hideLoading();
    }
    // const { morningList, afternoonList, eveningList } = loadSlotsForDate(response.content[0].date);
    // setState({ ...response, morningList, afternoonList, eveningList, date: response.content[0].date });
    hideLoading();

  };

  const proceedBook = async () => {
    if (state.date && state.selectedSlot) {
      showLoading();
      // calenderGATags('Slot Selection Proceed', centerDetails?.name, state.interval);
      const request = {
        // "booking_jiohealthhubid": user?.bookingHealthId,
        // "primary_jiohealthhubid": user?.primaryHealthId,
        "doctor_id": centerDetails?.doctor_id || booking?.doctor_id,
        "partner_consult_center_id": centerDetails?.partner_consult_center_id || booking?.partner_consult_center_id,
        "date": state.date,
        "slot_id": state.selectedSlot,
        "consultation_service_type": "4"
      }
      const response = await srBookSlots(request);

      if (lodash.get(response, "status") !== "success") {
        //error handling
        setState({ serviceError: true, errorMessage: lodash.get(response, "response.data.message", "Something went wrong, please try again") });
      }
      else {
        // store slot_id and date in context
        dispatch({ type: 'UPDATE_BOOKING', bookingData: { ...booking, slot_id: state.selectedSlot, date: state.date, time: state.selectedTime } })
        handleNext();
      }
      hideLoading();
    }
  };

  // const fireGaTags = () => {
  //   if (window.location.pathname === '/book-appointment/corporate') {
  //     sendPageViewEvent({ VirtualPageTitle: 'book-appointment/corporate/select-datetime' })
  //   } else {
  //     sendPageViewEvent({ VirtualPageTitle: 'book-appointment/all-centers/select-datetime' })
  //   }
  // }

  useEffect(() => {
    // fireGaTags()
    loadAllSlots();
  }, []);


  if (state.serviceError) return <ErrorComponent
    image='/icons/failedIcon.svg'
    text="Failed!"
    subText={state.errorMessage}
    showButton={false}
    textCss='error-text'
    subTextCss='error-text-sub'
    imageHeight='120px'
    imageWidth='120px'
  />



  return (
    <div className="calender__wrapper">
      {
        state?.contents?.length > 0 && (
          <>
            <h1 className="calender__title">{t('SELECT_DATE_TIME')}</h1>
            <h1 className="calender__month">{moment(state?.contents[0].date, 'DD-MM-YYYY').format("MMMM YYYY")}</h1>
            <Slider t={t} dates={state.contents} dateSelected={dateSelected} />
            {
              (state.morningList.length > 0 || state.afternoonList.length || state.eveningList.length) ? (
                <>
                  {
                    state.morningList.length > 0 && (
                      <Slot t={t} label="Morning" slots={state.morningList} selected={state.selectedSlot} setSelectedSlot={setSelectedSlot} />
                    )
                  }
                  {
                    state.afternoonList.length > 0 && (
                      <Slot t={t} label="Afternoon" slots={state.afternoonList} selected={state.selectedSlot} setSelectedSlot={setSelectedSlot} />
                    )
                  }
                  {
                    state.eveningList.length > 0 && (
                      <Slot t={t} label="Evening" slots={state.eveningList} selected={state.selectedSlot} setSelectedSlot={setSelectedSlot} />
                    )
                  }

                  <button className={["calender__proceed", !state.selectedSlot && "disable"].join(' ')} onClick={proceedBook}>{t('PROCEED')}</button>
                </>
              ) : (
                <UnavailableSlots t={t} />
              )
            }

          </>
        )
      }

    </div>

  )
}

export default Calender;